export default function parseErrorMessage(error) {
  if (typeof error === 'string') {
    return error;
  }

  if (error.response) {
    const data = error.response.data;
    if (typeof data?.error === 'object' && data.error !== null) {
      return data.error.message;
    }
    return data?.ERROR ?? data?.error;
  }

  if (error.message && typeof error.message === 'string') {
    return error.message;
  }
}
